import React from "react";
import { Page } from "../../activities/AppPage";
import ImportantInformationScreen from "./ImportantInformationScreen";
import { postingRequirementsTypes } from "./pdfDocuments";
interface Props {
  onClickGoBack: () => void;
  onRequestNavigate: (page: Page) => void;
}

const ImportantInformationActivity = (props: Props) => {
  const requirements = postingRequirementsTypes;

  return (
    <ImportantInformationScreen
      requirements={requirements}
      onClickGoBack={props.onClickGoBack}
      onRequestNavigate={props.onRequestNavigate}
    />
  );
};

export default ImportantInformationActivity;
